exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".common_form_search[data-v-867f83b0]{padding:15px 30px 0}.child_page[data-v-867f83b0]{padding-bottom:15px}.nav_tabs[data-v-867f83b0]{padding-top:15px}\n", ""]);

// exports
